import useGeoLocation from "../../tools/useGeolocation";
import { Button, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  fetchAllDeviceData,
  selectDeviceAllInfoData,
  selectDeviceType,
  userCheckInu,
  userCheckWal,
} from "../../store/deviceData/deviceDataSlice";

export default function MapPage() {
  const { location, refreshLocation } = useGeoLocation();
  const nowLocation = {
    lat: location.coordinates?.lat ?? 35.2417951,
    lng: location.coordinates?.lng ?? 129.0834828,

  };
  const [search, setSearch] = useState<string>("");
  const deviceType = useAppSelector(selectDeviceType);
  const deviceAllInfoData = useAppSelector(selectDeviceAllInfoData);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchAllDeviceData({ deviceType, search, searchType: "prd_id" }));
  }, [deviceType, search]);

  useEffect(() => {
    let center = new kakao.maps.LatLng(nowLocation.lat, nowLocation.lng)
    let container = document.getElementById('map');
    let options = {
      center: center,
      level: 5
    };
    let map = new kakao.maps.Map(container!, options);

    deviceAllInfoData.filter((e) => e.lat != null).forEach((item) => {
      var marker = new kakao.maps.Marker({
        position: new kakao.maps.LatLng(item.lat, item.lng)
      });
      marker.setMap(map);

      var infowindow = new kakao.maps.InfoWindow({
        position: marker.getPosition(),
      });
      kakao.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });

      var content = document.createElement('div');
      content.innerHTML = '지점:' + item.spot_code + "<br>" + '이름:' + item.name;

      var closeBtn = document.createElement('button');
      closeBtn.innerHTML = '닫기';
      closeBtn.onclick = function () {
        infowindow.close();
      };
      content.appendChild(closeBtn);
      infowindow.setContent(content)
    }
    )
    const close = document.querySelectorAll(".close");

  }, [location.coordinates, deviceAllInfoData])

  return (
    <>
      <Row>
        <Col>
          <div>
            현재 위치 : <Button onClick={refreshLocation}>새로고침</Button>
          </div>
          <div>
            {location.coordinates?.lat} , {location.coordinates?.lng}
          </div>
        </Col>
        <Col>
          <input
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            placeholder="아이디검색"
          />
          <div>
            <input
              type="radio"
              id="inu"
              checked={deviceType === "inu"}
              onChange={() => dispatch(userCheckInu())}
            />
            <label htmlFor="inu">inu</label>
            <input
              type="radio"
              id="wal"
              checked={deviceType === "wal"}
              onChange={() => dispatch(userCheckWal())}
            />
            <label htmlFor="wal">wal</label>
          </div>
        </Col>
      </Row>
      <div id="map" style={{ width: "100vw", height: "80vh" }} />
    </>
  );
}
